import { render } from "./FilePanelComponent.vue?vue&type=template&id=009cbd64&scoped=true"
import script from "./FilePanelComponent.vue?vue&type=script&lang=js"
export * from "./FilePanelComponent.vue?vue&type=script&lang=js"

import "./FilePanelComponent.vue?vue&type=style&index=0&id=009cbd64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009cbd64"]])

export default __exports__